import {CardMedia, Grid, Typography} from '@mui/material';
import {
    ItemImageLatestUpdateDTO,
    ItemTextLatestUpdateDTO,
    ItemVideoLatestUpdateDTO,
    LatestUpdateItemDTO,
} from '../../../../api/models';

export const LatestUpdateComponent = ({update, color}: {update: LatestUpdateItemDTO | undefined; color?: string}) => {
    if (update) {
        switch (update.updateType) {
            case 'Text':
                const textUpdate = update as ItemTextLatestUpdateDTO;
                return (
                    <Grid container>
                        <Grid item md={12} xs={12} sm={12}>
                            <Typography
                                sx={{
                                    marginTop: 1,
                                    fontWeight: 500,
                                    color: color ?? 'black',
                                    fontFamily: 'Poppins',
                                }}
                                variant='body1'>
                                {new Date(textUpdate.createdAt).toDateString()}
                            </Typography>
                            <Typography
                                sx={{
                                    marginTop: 1,
                                    fontWeight: 300,
                                    color: color ?? 'black',
                                    fontFamily: 'Poppins',
                                }}
                                variant='body1'>
                                {textUpdate.text.text}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            case 'Image':
                const imageUpdate = update as ItemImageLatestUpdateDTO;
                return (
                    <Grid container>
                        <Grid item md={3} xs={3} sm={3} />
                        <Grid item md={6} xs={6} sm={6}>
                            <CardMedia component='img' className={'ImageUpdate'} src={imageUpdate.url} />
                        </Grid>
                    </Grid>
                );
            case 'Video':
                const videoUpdate = update as ItemVideoLatestUpdateDTO;
                return (
                    <Grid container>
                        <Grid item md={3} xs={3} sm={3} />
                        <Grid item md={6} xs={6} sm={6}>
                            <CardMedia component='video' className={'VideoUpdate'} src={videoUpdate.url} autoPlay />
                        </Grid>
                    </Grid>
                );
        }
    }
};
